import { useEffect, useState } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import { useSearchParams, useNavigate } from "react-router-dom";
import Loading from "../SpinnerAndError/Loading";

const OrderNotSuccessfullPage = () => {
  const token = window.localStorage.getItem("token");
  const token2 = token.slice(1, -1);

  let navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/dashboard");
    }, "5000");
  }, []);

  return (
    <Container fluid className="container-dashboard-page">
      <Helmet>
        <style>{"body { background-color: #F5F5F5; }"}</style>
      </Helmet>
      <Row>
        <Col>
          <div>
            <Alert
              variant={"danger"}
              style={{
                textAlign: "center",
                position: "fixed",
                left: "50%",
                top: "30%",
                transform: "translate(-50%, -50%)",
                borderRadius: "8px",
                padding: "35px",
              }}
            >
              <p className="order-successfull-alert-message-p-texts">
                Something went wrong. Please try again.
              </p>
              <p className="order-successfull-alert-message-p-texts">
                We will now redirect you back to the dashboard page.
              </p>
              <Loading></Loading>
            </Alert>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderNotSuccessfullPage;
